import React from "react";
import PolicyPage from "./PolicyPage";

const sections = [
  {
    title: "When to open a delivery case",
    paragraphs: ["Start a case when an order-specific delivery estimate has passed, delivery correspondence conflicts with what occurred, the parcel cannot be located, the outer package or product is damaged, a liquid has leaked, or the contents do not match the accepted order. Contact customer service without avoidable delay after discovery so available evidence can be preserved."],
  },
  {
    title: "Details needed for delay or loss",
    items: [
      "order reference and purchaser email;",
      "recipient and delivery destination as entered at checkout;",
      "the relevant dispatch, delivery or status message;",
      "a concise account of the expected and actual events;",
      "confirmation of any safe location or building reception already checked.",
    ],
  },
  {
    title: "Investigation sequence",
    paragraphs: ["The order record and destination are compared first. Available fulfilment and delivery events are then reviewed, and a provider enquiry is opened where the service used supports one. The customer must not send card credentials. The result is communicated when the available records and external enquiry permit a reasoned decision."],
  },
  {
    title: "Damage evidence and safety",
    paragraphs: ["Keep the outer parcel, label, inner packing and affected product. Photograph the package before rearranging it when safe. Do not handle broken glass or ceramic with bare hands, use a leaking cosmetic, or give a damaged toy or loose component to a child. Isolate the hazard and explain safe disposal needs in the first message."],
  },
  {
    title: "Incorrect or incomplete contents",
    paragraphs: ["List everything received and identify the absent, extra or incorrect item, including its colour or size. Keep product sleeves, tags and packing together until the order record has been checked. An extra item should not be used while instructions are pending."],
  },
  {
    title: "Resolution",
    paragraphs: ["The confirmed event, available stock, product condition and applicable rights determine whether the proper result is continued delivery action, replacement, correction, refund or another remedy. A delivery status alone is not treated as conclusive where credible contrary evidence is supplied. This process does not remove a mandatory remedy."],
  },
];

export default function PackageIssues() {
  return <PolicyPage title="Lost, Delayed & Damaged Packages" intro="Evidence, safety steps and review stages for parcels that do not arrive as expected." sections={sections} related={[["Shipping & Delivery", "/shipping"], ["Returns, Refunds & Exchanges", "/returns"], ["Packaging & Sustainability", "/packaging"]]} />;
}
